import { z } from "zod";

const buildArrivalGuideFormSchema = () =>
  z.object({
    wifiInstructions: z.string().optional(),
    directions: z.string().optional(),
  });

type ArrivalGuideFormValues = z.infer<
  ReturnType<typeof buildArrivalGuideFormSchema>
>;

export { buildArrivalGuideFormSchema };
export type { ArrivalGuideFormValues };
